import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import LeaveApproval from "./LeaveApproval";
import PCF from "./PCF/PCF";
import ResignApproval from "./ResignApproval";
import LoadingBtn from "../../../Widgets/LoadingBtn";
import { AlertNotif } from "../../../../Library/AlertNotif";
import { GET_STUDENT_ACTIVITY } from "../../APIS";
import { DecodeURIComponentSafe } from "../../../../Library/GlobalHelper";
import { Error404 } from "../../../../Library/LoaderPage";

export function DetailActivity({ studentData }) {
  const { id } = useParams();
  const eventid = id ? DecodeURIComponentSafe(id) : 0;
  const [activity, setActivity] = useState({
    loading: true,
    data: [],
    message: "",
  });
  const [selectedActivity, setSelectedActivity] = useState([]);
  const [actType, setActType] = useState("");

  const ReloadData = async (param) => {
    setActivity({ loading: true, data: [], message: "" });
    const result = await GET_STUDENT_ACTIVITY(param);
    if (result.data && Object.values(result.data).length > 0) {
      console.log(result.data);
      setActivity({ loading: false, data: result.data, message: "" });
      const find_event_id = result.data.find(
        (item) => item.id === parseInt(eventid)
      );
      setSelectedActivity(find_event_id);
      setActType(find_event_id?.student_activity?.name);
      console.log(find_event_id);
    } else {
      setActivity(result);
      setSelectedActivity([]);
    }
  };

  useEffect(() => {
    const param = {
      studentid: studentData.studentid,
    };
    ReloadData(param);
  }, [studentData]);

  if (activity.loading) {
    return <LoadingBtn />;
  } else if (activity.message) {
    return <AlertNotif message={activity.message} color={"info"} />;
  } else if (Object.values(activity.data).length > 0) {
    if (actType === "Leave") {
      return (
        <LeaveApproval data={selectedActivity} />
      );
    } else if (actType === "PCF" || actType === "PCF Revision" || studentData) {
      return (
        <PCF
          data={selectedActivity}
          students={{ data: studentData }}
          stdStatus={studentData}
        />
      );
    } else if (actType === "Resign") {
      return (
        <ResignApproval
          data={
            selectedActivity.value &&
            Object.values(selectedActivity.value).length > 0
              ? selectedActivity.value
              : []
          }
        />
      );
    }else{
        return <Error404 />
    }

    
  } else {
    return "";
  }
}
